// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"670":"component---src-pages-sanity-post-slug-current-jsx","678":"component---src-pages-index-js","740":"700199ab","883":"component---src-pages-404-js"}[chunkId] + "-" + {"670":"bfe26a39b00a398caa11","678":"c6c117d732fb79f7771f","740":"7a8cbc121763a261dab0","883":"64a62cd583b280764240"}[chunkId] + ".js";
};